module.exports = __webpack_public_path__ + "img/FMCS4.d8d14c72.png";